import { Component, inject, signal, OnInit, HostListener, AfterViewInit } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { ProgressBarComponent } from "./kernel/shared/modules/spinner/components/progress-bar/progress-bar.component";
import { Toast } from "primeng/toast";
import { NgHttpLoaderComponent, SpinnerVisibilityService } from "ng-http-loader";
import { NotificationService } from "./kernel/notifications/notification.config";
import { TranslateModule } from "@ngx-translate/core";
import { ToastService } from "./kernel/tools/message/message.config";
import { TranslationService } from "./kernel/translations/translation.service";
import { take } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  imports: [RouterOutlet, Toast, NgHttpLoaderComponent, TranslateModule],
})
export class AppComponent implements OnInit, AfterViewInit {
  progressBar = ProgressBarComponent;
  loadingRoute = signal<boolean>(false);

  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private toast = inject(ToastService);
  private translationService = inject(TranslationService);

  private isNotificationRequested = false;

  @HostListener("click")
  requestNotificationPermission() {
    if (!this.isNotificationRequested && this.notificationService.getNotificationPermission() === "default") {
      this.isNotificationRequested = true;
      this.notificationService.requestToken().subscribe();
    }
  }

  constructor(private loader: SpinnerVisibilityService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loader.show();
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loader.hide();
      }
    });
  }
  ngOnInit() {
    this.checkRouteState();
  }

  ngAfterViewInit() {
    this.translationService
      .waitUntilTranslationLoaded("root")
      .pipe(take(1))
      .subscribe(() => {
        this.toast.popMessageFromSessionStorage();
      });
  }

  private checkRouteState() {
    this.router.events.subscribe({
      next: event => {
        if (event instanceof NavigationStart) {
          this.loadingRoute.set(true);
        }
        if (event instanceof NavigationEnd) {
          this.loadingRoute.set(false);
        }

        // Set loadingRoute state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
          this.loadingRoute.set(false);
        }
        if (event instanceof NavigationError) {
          this.loadingRoute.set(false);
        }
      },
    });
  }
}
